import { writeArrayBufferToDisk } from './writeArrayBufferToDisk'
import type { FileId } from '../../../shared/domain/files/types.no-deps'
import { fileBuffer } from '../../../app-core/lib/upload/buffer'

export const writeHtmlFileToDisk = (fileId: FileId, file: File): Promise<void> =>
    writeArrayBufferToDisk(fileId, fileBuffer(file))
